module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f44c.464b4c27.svg";